<template>
  <div class="text">
      <div v-if="isVerified">
        <h1>{{ $t('driver_onboarding.profile.contract.contract_is_signed_title') }} </h1>  
        <span>{{ $t('driver_onboarding.profile.contract.contract_is_signed_desc') }}</span>
        <br />
      </div>
      <div v-else>
        <h1>{{ $t('driver_onboarding.profile.contract.contract_is_verifying_title') }} </h1>  
        <span v-html="$t('driver_onboarding.profile.contract.contract_is_verifying_desc')"></span>
        <br />
      </div>
      <p class="scan-qr">{{ $t('driver_onboarding.profile.contract.contract_is_signed_sub_desc') }}</p>
      <div class="is-flex">
          <img src="/img/onboard-driver/qr.svg" width="150" height="150" alt="">
      </div>
      <div class="guide">
        <p>Có thể bạn cần:</p>
        <a class="intro" href="https://ahamove.com/thu-nhap-nap-rut-tien-tai-khoan/">Hướng dẫn chạy đơn, nạp rút tiền</a>
        <br />
        <a class="intro" href="https://ahamove.com/nhin-lai-sieu-hoi-anh-tai-2019/">Hướng dẫn sử dụng ví điện tử MOMO</a>
        <br />
        <a class="intro" href="https://ahamove.com/chatluong">Quy định đảm bảo chất lượng</a>
        <br />
        <a class="intro" href="/help-center/delete-account">Xoá tài khoản</a>
      </div>
    </div>
</template>

<script>
export default {
  props: {
    isVerified: {
      type: Boolean
    }
  },
  mounted() {
    if(this.isVerified) {
      this.$store.state.active_step = 6
    }
  }
}
</script>

